export default __webpack_public_path__ + "static/media/OnboardSteps_Image.61db0463.png";